module.exports = __webpack_public_path__ + "static/media/navCar.1f2013da.png";